import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as TimelineService from "_services/timeline-service";

const initialState = {
    status: "idle",
    error: null,
};

// Create break task thunk - posts to /api/v1/timeline/staff/staff-shift
export const createBreakTask = createAsyncThunk(
    "createBreakTask/create",
    async (payload) => {
        const {
            employee,
            breakStartTime,
            breakEndTime,
        } = payload;

        // Convert HH:mm into ISO date string anchored to today
        const createISOFromTime = (timeString) => {
            const [hours, minutes] = timeString.split(':').map(Number);
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);
            return date.toISOString();
        };

        const breakPayload = {
            userId: employee?.userId,
            airport: employee?.airport,
            employeeId: employee?.employeeId,
            shift: {
                start: createISOFromTime(breakStartTime),
                end: createISOFromTime(breakEndTime),
            },
            isBreakTask: true,
            v2: true
        };

        return TimelineService.saveEmployeeShiftService(breakPayload);
    }
);

const createBreakTaskSlice = createSlice({
    name: "createBreakTask",
    initialState,
    reducers: {
        resetCreateBreakTaskStatus: (state) => {
            state.status = "idle";
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createBreakTask.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(createBreakTask.fulfilled, (state) => {
                state.status = "succeeded";
            })
            .addCase(createBreakTask.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error?.message || "Failed to create break task";
            });
    },
});

export const { resetCreateBreakTaskStatus } = createBreakTaskSlice.actions;

// Selectors
export const selectCreateBreakTaskStatus = (state) => state.createBreakTask?.status;
export const selectCreateBreakTaskError = (state) => state.createBreakTask?.error;

export default createBreakTaskSlice.reducer;
